"use strict";

exports.__esModule = true;
exports.Phone = /^\(?(\d{2})\)?\s?(\d{4,5})-?(\d{4})$/;
exports.PhoneMask = /^\(?(\d{1,2})\)?\s?(\d{1,4})?-?(\d{1,4})?(.*)?$/;
exports.PhoneMaskCell = /^\(?(\d{1,2})\)?\s?(\d{1,5})?-?(\d{1,4})?(.*)?$/;
exports.Cep = /^(\d{5})-?(\d{3})$/;
exports.CepMask = /^(\d{1,5})(\d{1,3})?(.*)?$/;
exports.Cpf = /^(\d{3})(\.?\d{3})(\.?\d{3})-?(\d{2})$/;
exports.CpfMask = /^(\d{1,3})\.?(\d{1,3})?\.?(\d{1,3})?\-?(\d{1,2})?(.*)?$/;
exports.Cnpj = /^(\d{2})(\.?\d{3})(\.?\d{3})\/?(\d{4})-?(\d{2})$/;
exports.CnpjMask = /^(\d{1,2})\.?(\d{1,3})?\.?(\d{1,3})?\/?(\d{1,4})?-?(\d{1,2})?(.*)?/;
exports.Pis = /^(\d{2})(\.?\d{5})(\.?\d{3})-?(\d{1})$/;
exports.PisMask = /^(\d{1,2})\.?(\d{1,5})?\.?(\d{1,3})?\-?(\d{1})?(.*)?$/;
exports.Uuid = /^\{?([a-f0-9]{8})(-?[a-f0-9]{4}){3}(-?[a-f0-9]{12})\}?$/;
exports.Email = /^\w+([^@]+)*@\w+([\.-]?\w+)*(\.\w{2,10})/;
exports.RegularDate = /^([0-9]{2})\/?([0-9]{2})\/?([0-9]{4})$/;
exports.RegularDateMask = /^([0-9]{1,2})\/?([0-9]{1,2})?\/?([0-9]{1,4})?(.*)?$/;
exports.IsoDate = /^([0-9]{4})(\-[0-9]{2}){2}T(:?[0-9]{2}){3}(\.[0-9]{3})Z$/;
exports.UtcDate = /^([A-z]{3}),\s([0-9]{2})\s([A-z]{3})\s([0-9]{4})\s(:?[0-9]{2}){3}\sGMT/;
exports.Url = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;